import { Injectable } from '@angular/core'

export enum SessionStorageKey {
  REDIRECT_URL = 'redirectUrl',
  SSO_IN_PROGRESS = 'ssoInProgress',
}

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  /**
   * Set an item in session storage
   * @param key The key to store the value under
   * @param value The value to store
   */
  set(key: string, value: any): void {
    try {
      const serializedValue = JSON.stringify(value)
      sessionStorage.setItem(key, serializedValue)
    } catch (error) {
      console.error('Error saving to session storage', error)
    }
  }

  /**
   * Get an item from session storage
   * @param key The key to retrieve
   * @returns The stored value or null if not found
   */
  get<T>(key: string): T | null {
    try {
      const item = sessionStorage.getItem(key)
      return item ? JSON.parse(item) : null
    } catch (error) {
      console.error('Error getting from session storage', error)
      return null
    }
  }

  /**
   * Remove an item from session storage
   * @param key The key to remove
   */
  remove(key: string): void {
    try {
      sessionStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from session storage', error)
    }
  }

  /**
   * Clear all items from session storage
   */
  clear(): void {
    try {
      sessionStorage.clear()
    } catch (error) {
      console.error('Error clearing session storage', error)
    }
  }

  /**
   * Check if a key exists in session storage
   * @param key The key to check
   * @returns True if the key exists, false otherwise
   */
  exists(key: string): boolean {
    return sessionStorage.getItem(key) !== null
  }
}
